import React, { useState } from 'react';
import { CheckCircle2, ShieldCheck, Phone, Tag } from 'lucide-react';
const PHONE = '586-203-3701';
export function QuoteForm() {
  const [submitted, setSubmitted] = useState(false);
  const [form, setForm] = useState({
    name: '',
    phone: '',
    email: '',
    zip: '',
    service: 'Full Shingle Roof Replacement',
    timeline: 'ASAP — I have damage or a leak',
    notes: ''
  });
  const update = (k: string, v: string) => setForm(f => ({
    ...f,
    [k]: v
  }));
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };
  return <section id="quote-form" className="bg-[#1a2332] py-20 sm:py-24 relative overflow-hidden" data-id="element-203">
      <div className="absolute inset-0 shingle-pattern opacity-10" data-id="element-204" />
      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-205">
        <div className="grid lg:grid-cols-5 gap-10 items-start" data-id="element-206">
          {/* Left column: pitch */}
          <div className="lg:col-span-2 text-white" data-id="element-207">
            <div className="inline-flex items-center gap-2 bg-[#2DB8E0]/20 border border-[#2DB8E0]/40 rounded-full px-4 py-1.5 mb-5" data-id="element-208">
              <Tag className="w-4 h-4 text-[#2DB8E0]" data-id="element-209" />
              <span className="text-[#2DB8E0] font-bold text-xs uppercase tracking-wider" data-id="element-210">
                $500 Off — Limited Time
              </span>
            </div>
            <h2 className="font-display italic text-4xl sm:text-5xl leading-tight mb-5" data-id="element-211">
              Get Your Free Roof Quote Today
            </h2>
            <p className="text-white/80 leading-relaxed mb-8" data-id="element-212">
              Fill out the form and a Moceri professional will reach out within
              one business day to schedule your free, no-obligation inspection.
              Mention this page to lock in your
              <span className="text-[#2DB8E0] font-bold" data-id="element-213"> $500 discount</span>.
            </p>

            <ul className="space-y-3 mb-8" data-id="element-214">
              {['Free on-site inspection', 'Upfront, written pricing — no surprises', 'Premium shingles built for Michigan weather', 'Financing available — ask about options'].map(i => <li key={i} className="flex items-start gap-3" data-id="element-215">
                  <CheckCircle2 className="w-5 h-5 text-[#2DB8E0] flex-shrink-0 mt-0.5" data-id="element-216" />
                  <span className="text-white/90" data-id="element-217">{i}</span>
                </li>)}
            </ul>

            <a href={`tel:${PHONE.replace(/-/g, '')}`} className="inline-flex items-center gap-3 text-white hover:text-[#2DB8E0] font-bold transition-colors" data-id="element-218">
              <Phone className="w-5 h-5 text-[#2DB8E0]" data-id="element-219" />
              Prefer to call? {PHONE}
            </a>
          </div>

          {/* Right column: form card */}
          <div className="lg:col-span-3" data-id="element-220">
            <div className="bg-white rounded-2xl shadow-2xl p-6 sm:p-8 relative overflow-hidden" data-id="element-221">
              <div className="absolute top-0 left-0 w-full h-2 bg-[#2DB8E0]" data-id="element-222" />

              {submitted ? <div className="text-center py-10" data-id="element-223">
                  <div className="w-16 h-16 bg-[#2DB8E0]/10 rounded-full flex items-center justify-center mx-auto mb-5" data-id="element-224">
                    <CheckCircle2 className="w-9 h-9 text-[#2DB8E0]" data-id="element-225" />
                  </div>
                  <h3 className="font-display italic text-3xl text-[#1a2332] mb-3" data-id="element-226">
                    Thanks, {form.name.split(' ')[0] || 'friend'}!
                  </h3>
                  <p className="text-slate-600 mb-6 max-w-md mx-auto" data-id="element-227">
                    We've received your request and a Moceri team member will
                    reach out within one business day. Need it sooner?
                  </p>
                  <a href={`tel:${PHONE.replace(/-/g, '')}`} className="inline-flex items-center gap-2 bg-[#2DB8E0] hover:bg-[#1a9cc4] text-white font-bold px-6 py-3 rounded-full transition-colors" data-id="element-228">
                    <Phone className="w-5 h-5" data-id="element-229" /> Call {PHONE}
                  </a>
                </div> : <form onSubmit={handleSubmit} className="space-y-4" data-id="element-230">
                  <h3 className="font-display italic text-3xl text-[#1a2332] mb-1" data-id="element-231">
                    Claim Your $500 Off
                  </h3>
                  <p className="text-sm text-slate-500 mb-4" data-id="element-232">
                    No spam. No obligation. Response within 1 business day.
                  </p>

                  <div data-id="element-233">
                    <label htmlFor="name" className="block text-sm font-semibold text-[#1a2332] mb-1.5" data-id="element-234">
                      Full Name <span className="text-[#2DB8E0]" data-id="element-235">*</span>
                    </label>
                    <input id="name" type="text" required value={form.name} onChange={e => update('name', e.target.value)} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#2DB8E0] focus:border-[#2DB8E0] outline-none transition-all" placeholder="John Smith" data-id="element-236" />
                  </div>

                  <div className="grid sm:grid-cols-2 gap-4" data-id="element-237">
                    <div data-id="element-238">
                      <label htmlFor="phone" className="block text-sm font-semibold text-[#1a2332] mb-1.5" data-id="element-239">
                        Phone <span className="text-[#2DB8E0]" data-id="element-240">*</span>
                      </label>
                      <input id="phone" type="tel" required value={form.phone} onChange={e => update('phone', e.target.value)} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#2DB8E0] focus:border-[#2DB8E0] outline-none transition-all" placeholder="(586) 555-0100" data-id="element-241" />
                    </div>
                    <div data-id="element-242">
                      <label htmlFor="zip" className="block text-sm font-semibold text-[#1a2332] mb-1.5" data-id="element-243">
                        ZIP Code <span className="text-[#2DB8E0]" data-id="element-244">*</span>
                      </label>
                      <input id="zip" type="text" required value={form.zip} onChange={e => update('zip', e.target.value)} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#2DB8E0] focus:border-[#2DB8E0] outline-none transition-all" placeholder="48081" data-id="element-245" />
                    </div>
                  </div>

                  <div data-id="element-246">
                    <label htmlFor="email" className="block text-sm font-semibold text-[#1a2332] mb-1.5" data-id="element-247">
                      Email <span className="text-[#2DB8E0]" data-id="element-248">*</span>
                    </label>
                    <input id="email" type="email" required value={form.email} onChange={e => update('email', e.target.value)} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#2DB8E0] focus:border-[#2DB8E0] outline-none transition-all" placeholder="john@example.com" data-id="element-249" />
                  </div>

                  <div className="grid sm:grid-cols-2 gap-4" data-id="element-250">
                    <div data-id="element-251">
                      <label htmlFor="service" className="block text-sm font-semibold text-[#1a2332] mb-1.5" data-id="element-252">
                        Service Needed
                      </label>
                      <select id="service" value={form.service} onChange={e => update('service', e.target.value)} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#2DB8E0] focus:border-[#2DB8E0] outline-none transition-all bg-white" data-id="element-253">
                        <option data-id="element-254">Full Shingle Roof Replacement</option>
                        <option data-id="element-255">Asphalt Shingle Roof</option>
                        <option data-id="element-256">Storm/Hail Damage Inspection</option>
                        <option data-id="element-257">Not sure — need advice</option>
                      </select>
                    </div>
                    <div data-id="element-258">
                      <label htmlFor="timeline" className="block text-sm font-semibold text-[#1a2332] mb-1.5" data-id="element-259">
                        Timeline
                      </label>
                      <select id="timeline" value={form.timeline} onChange={e => update('timeline', e.target.value)} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#2DB8E0] focus:border-[#2DB8E0] outline-none transition-all bg-white" data-id="element-260">
                        <option data-id="element-261">ASAP — I have damage or a leak</option>
                        <option data-id="element-262">Within 1 month</option>
                        <option data-id="element-263">1–3 months</option>
                        <option data-id="element-264">Just getting quotes</option>
                      </select>
                    </div>
                  </div>

                  <div data-id="element-265">
                    <label htmlFor="notes" className="block text-sm font-semibold text-[#1a2332] mb-1.5" data-id="element-266">
                      Tell us about your project{' '}
                      <span className="text-slate-400 font-normal" data-id="element-267">
                        (optional)
                      </span>
                    </label>
                    <textarea id="notes" rows={3} value={form.notes} onChange={e => update('notes', e.target.value)} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#2DB8E0] focus:border-[#2DB8E0] outline-none transition-all resize-none" placeholder="e.g. Two-story colonial, missing shingles after last storm…" data-id="element-268" />
                  </div>

                  <button type="submit" className="w-full bg-[#2DB8E0] hover:bg-[#1a9cc4] text-white font-bold text-lg py-4 rounded-full transition-all shadow-md hover:shadow-lg mt-2" data-id="element-269">
                    Get My Free Quote + $500 Off
                  </button>

                  <p className="text-xs text-center text-slate-500 flex items-center justify-center gap-1.5" data-id="element-270">
                    <ShieldCheck className="w-3.5 h-3.5" data-id="element-271" /> Your information is
                    secure and private.
                  </p>
                </form>}
            </div>
          </div>
        </div>
      </div>
    </section>;
}